import {
  FrontendApi,
  RecoveryFlow,
  UpdateRecoveryFlowBody,
} from "@ory/kratos-client";
import { isObject } from "ahooks/es/utils";
import {
  getRedirectBrowserTo,
  isFlowInstance,
  isSessionAlreadyAvailableError,
} from "../../../api";

export async function getRecoveryFlow(
  api: FrontendApi,
  flowId: string
): Promise<RecoveryFlow> {
  return api
    .getRecoveryFlow({
      id: flowId,
    })
    .then((res) => res.data);
}

export async function getOrInitiateRecoveryFlow(
  api: FrontendApi,
  options: {
    flowId?: string;
    returnTo?: string;
  }
): Promise<RecoveryFlow | null> {
  if (options?.flowId) {
    return getRecoveryFlow(api, options.flowId).catch(() =>
      initiateRecoveryFlow(api, {
        returnTo: options.returnTo,
      })
    );
  }
  return initiateRecoveryFlow(api, {
    returnTo: options.returnTo,
  });
}

export async function initiateRecoveryFlow(
  api: FrontendApi,
  options: {
    returnTo?: string;
  }
): Promise<RecoveryFlow | null> {
  try {
    const response = await api.createBrowserRecoveryFlow({
      returnTo: options.returnTo,
    });
    return response.data;
  } catch (err) {
    const response = isObject(err) ? err.response?.data : null;
    if (response && isSessionAlreadyAvailableError(response)) {
      return null;
    }
    throw err;
  }
}

export async function submitRecovery(
  api: FrontendApi,
  flowId: string,
  body: UpdateRecoveryFlowBody
): Promise<RecoveryFlow | null> {
  try {
    const response = await api.updateRecoveryFlow({
      flow: flowId,
      updateRecoveryFlowBody: body,
    });
    return response.data;
  } catch (err) {
    const httpResponse = isObject(err) ? err.response?.data : null;
    const redirectUrl = getRedirectBrowserTo(httpResponse);
    if (redirectUrl) {
      document.location = redirectUrl;
    } else if (isFlowInstance<RecoveryFlow>(httpResponse)) {
      return httpResponse;
    }
    return null;
  }
}
